// extracted by mini-css-extract-plugin
export var arrows = "_3i-6";
export var decrementer = "_3i-a";
export var disabled = "_3i-4";
export var error = "_3i-1";
export var hiddenText = "_3i-b";
export var incrementer = "_3i-9";
export var input = "_3i-8";
export var inputWrapper = "_3i-0";
export var leadingIcon = "_3i-c";
export var readonly = "_3i-3";
export var regular = "_3i-7";
export var small = "_3i-5";
export var warning = "_3i-2";